import * as React from 'react'

import { Alert, Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

type TouchableProps = React.ComponentProps<typeof Button>
type ModalProps = React.ComponentProps<typeof Modal>

interface Props {
  onSubmit: TouchableProps['onClick']
  onClose: ModalProps['onClose']
}

const AtsInstallModal = ({ onSubmit, onClose }: Props) => {
  return (
    <Modal
      illustration="monitor-flash"
      title={i18n.t('app_store_v2.apps.ats.dependency_install_modal.title')}
      description={
        <>
          {i18n.t('app_store_v2.apps.ats.dependency_install_modal.description')}
          <Box paddingTop="s16">
            <Alert color="warning">
              <Box alignItems="flexStart" flexDirection="row" gap="s4">
                <Box flexNoShrink>
                  <Icon.Medium icon="alert-circle" color="grey800" />
                </Box>
                <Text.Normal>
                  {i18n.t('app_store_v2.apps.ats.dependency_install_modal.warning_message')}{' '}
                  <a
                    href={i18n.t('app_store_v2.apps.ats.dependency_install_modal.link')}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {i18n.t('app_store_v2.apps.ats.dependency_install_modal.more_info')}
                  </a>
                </Text.Normal>
              </Box>
            </Alert>
          </Box>
        </>
      }
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={onSubmit}>
            {i18n.t('app_store_v2.apps.ats.dependency_install_modal.submit')}
          </Button>
        </>
      }
    />
  )
}

export default AtsInstallModal
